export const getters = {};

export default getters;
